import { getTemplate } from "../template-helper";
import Mustache from "mustache";
import { uuidv4 } from "../../util/utils";


const COMPONENT_NAME = "z-radio-list" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class RadioListComponent extends HTMLElement {
            constructor() {
                super();
                this.innerHTML = "" ;
                this.currentValue = null ;
            }

            connectedCallback(){
                this.currentValue = null ;
                this.init() ;
            }


            initMarkup(){
                if(this.initDone){ 
                    return  ; 
                }
                this.initDone = true ;
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

            }
            init(){
                this.initMarkup() ;
                this.container = this.querySelector(".z-radio-list-container") ;
                this.input = this.querySelector(".z-radio-list-input") ;
                this.labelFields = (this.getAttribute("z-label-fields")||"").split(",").map(f=>f.trim()).filter(f=>!!f) ;
                this.fieldId = (this.getAttribute("z-field-id")||"_id") ;
                this.name = this.getAttribute("name") || uuidv4();
                
                this.currentValue = this.getAttribute("value") ;

                this.applyReadOnly() ;
                this.applyRequired() ;
                this.applyOptions() ;
            }

            applyOptions(){
                const strOptions = this.getAttribute("z-options") ;
                let objOptions = null;
                try{
                    objOptions = JSON.parse(strOptions) ;
                }catch(err){
                    objOptions = [] ;
                }
                this.container.innerHTML = "" ;
                let valueFound = false;
                for(let obj of objOptions){
                    const div = document.createElement("DIV") ;
                    const mappedObj = this.mapValue(obj) ;
                    div.innerHTML = `<div class="form-check">
                    <input class="form-check-input" type="radio" name="${this.name}" 
                        id="${this.name}_${mappedObj.id}" value="${mappedObj.id}" ${mappedObj.id == this.currentValue?"checked":""}>
                        <label class="form-check-label" for="${this.name}_${mappedObj.id}">
                            ${mappedObj.label}
                        </label>
                    </div>` ;
                    this.container.appendChild(div) ;
                    div.querySelector("input").addEventListener("change", ()=>{
                        this.currentValue = "" ;
                        const radios = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                        for(let radio of radios){
                            if(radio.checked ){
                                this.currentValue = radio.value ;
                                this.input.value = radio.value ;
                            }
                        }
                        this.dispatchEvent(new Event('change', {bubbles: true}));
                    }) ;
                    if(this.currentValue && mappedObj.id == this.currentValue){
                        valueFound = true;
                    }
                }
                if(!valueFound){
                    this.currentValue = "" ;
                    this.input.value = "" ;
                }
            }

            get value() {
                return this.input.value ;
            }
            
            set value(value) {
                this.currentValue = value;
                this.input.value = value ;
                const radios = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                for(let radio of radios){
                    radio.checked = radio.value == value ;
                }
            }

            get required() {
                return this.input.hasAttribute("required") ;
            }
            
            set required(required) {
                this.input.setAttribute('required', required);
            }
            
            static get observedAttributes() {
                return ['value', 'readonly', "required", "z-options"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        if(newValue !== this.currentValue){
                            this.value = newValue ;
                        }
                    break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'readonly':
                        this.applyReadOnly() ;
                        break;
                    case 'z-options':
                        this.applyOptions() ;
                        break;
                }
            }

            applyReadOnly(){
                if(!this.input){ return ; }
                const radios = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                if(this.hasAttribute("readonly")){
                    for(let radio of radios){
                        radio.disabled = true ;
                    }
                }else{
                    for(let radio of radios){
                        radio.disabled = false ;
                    }
                }
            }

            mapValue(r){
                if(!r){
                    return {
                        id: null,
                        label: ""
                    } ;
                }
                
                var labelField = this.labelFields.map(function(f){ 
                    if(f.includes("{{")){ return f; }
                    return "{{"+f+"}}" ;
                }).join(" - ") ;
                Mustache.parse(labelField);
                var label = Mustache.render(labelField, r); 
                return {
                    id: r[this.fieldId||"id"],
                    label: label 
                } ;
            }
            
            applyRequired(){
                const required = this.hasAttribute("required") ;
                if(this.input){
                    if(required){
                        this.input.setAttribute("required", "required") ;
                    }else{
                        this.input.removeAttribute("required") ;
                    }
                }
            }
        }
        customElements.define(COMPONENT_NAME, RadioListComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
